import { render, staticRenderFns } from "./RiskAssessmentQuestionnaire.vue?vue&type=template&id=1202de5c&scoped=true&"
import script from "./RiskAssessmentQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentQuestionnaire.vue?vue&type=style&index=0&id=1202de5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202de5c",
  null
  
)

export default component.exports